export default __webpack_public_path__ + "static/media/shutterstock_611808665.6f3ba6e6.png";